import * as actionTypes from "../actionTypes";

const initialState = {
  allData: [],
  loading: false,
  error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_BLOGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.FETCH_BLOGS_SUCCESS:
      return {
        ...state,
        allData: action.payload,
        loading: false,
      };
    case actionTypes.FETCH_BLOGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case actionTypes.UPDATE_BLOGS:
      return {
        ...state,
        allData: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
